@if (!mobile) {
  <div
  class="dialog--header">{{ 'default.changelogTitle' | blah }}</div>
}
<mat-dialog-content class="changelog-dialog-content">
  <app-changelog [changelogEntriesInput]="changelogEntries"
  [mobile]="mobile"></app-changelog>
</mat-dialog-content>
@if (!mobile) {
  <mat-dialog-actions
    align="end">
    <button mat-button
    mat-dialog-close>{{ 'default.close' | blah | uppercase }}</button>
  </mat-dialog-actions>
}